import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';

import { USER_ROLE } from '../models';
import { UserStoreService } from '../store';

@Injectable({
  providedIn: 'root',
})
export class PermissionService {
  private readonly store = inject(UserStoreService);

  private hasRole(...roles: USER_ROLE[]): Observable<boolean> {
    return this.store.user$.pipe(map((data) => roles.some((r) => data.roles.includes(r))));
  }

  public get isPartnerUser$(): Observable<boolean> {
    return this.hasRole(USER_ROLE.ROLE_PARTNER_USER);
  }

  public get isPartner$(): Observable<boolean> {
    return this.hasRole(USER_ROLE.ROLE_PARTNER_ADMIN);
  }

  public get isSupervisor$(): Observable<boolean> {
    return this.hasRole(USER_ROLE.ROLE_SUPERVISOR);
  }
}
